import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CharacteristicsTypeFilterComponent } from './characteristics-type-filter.component';
import { CommonsLibModule } from 'commons-lib';

@NgModule({
    imports: [
        CommonModule,
        CommonsLibModule
    ],
    declarations: [ CharacteristicsTypeFilterComponent ],
    exports: [ CharacteristicsTypeFilterComponent ],
})
export class CharacteristicsTypeFilterModule { }
